<style>

</style>

<template>
  <div class="Create alignment">

    <template>
      <v-form ref="form">
      <v-flex xs12 sm12>
        <h3 v-if="edit" class="styleHeader" style="margin-bottom: 31px">Operatore - Modifica</h3>
        <h3 v-else class="styleHeader" style="margin-bottom: 31px">Operatore - Aggiungi</h3>
        <v-card class="styleDataTable">
          <form>
            <v-select class="styleAlignementCard"
              v-model="Companies"
              label="Companies"
              required
              :items="comp"
              :error-messages="CompaniesErrors"
              item-text="name"
              item-value="code"
              @input="$v.Companies.$touch()"
              @blur="$v.Companies.$touch()"
            ></v-select>
            <v-autocomplete
                v-model="Mail"
                label="Mail"
                :rules="[rules.isFercam]"
                required
                v-bind:items="Mails"
                :error-messages="MailErrors"
                :loading="loadingMail"
                @input.native="loadMail"         
                item-text="Email"
                item-value="Email"
                @change="changeMail"
                @blur="$v.Mail.$touch()"
              >
                <template slot="selection" slot-scope="data">
                  {{ data.item.Email }}
                </template> 
            </v-autocomplete>
            <v-text-field
              v-model="Name"
              label="Nome"
              required
              :error-messages="NameErrors"
              @input="$v.Name.$touch()"
              @blur="$v.Name.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="Surname"
              label="Cognome"
              required
              :error-messages="SurnameErrors"
              @input="$v.Surname.$touch()"
              @blur="$v.Surname.$touch()"
            ></v-text-field>
          </form>
        </v-card>
          <v-btn 
            class="white--text styleButtonTop styleAlignementSaveButton"
            @click="submit()"
            color="#5c6366">
            <v-icon left>check_circle</v-icon>
            Salva 
          </v-btn>
          <v-btn 
            class="styleButtonTop"
            @click="back()">
            <v-icon left>remove_circle</v-icon>
            Annulla
          </v-btn>
      </v-flex>
      </v-form>
      <v-alert :value="errorAlert" type="error" transition="scale-transition">{{
        errorMessage
      }}</v-alert>
    </template>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import router from "@/router/index.js";
import debounce from "debounce";
import companiesApi from "../../apiLogisticsTool/companiesApi.js";
import operatorsApi from "../../apiLogisticsTool/operatorsApi.js";
import umApi from "../../apiLogisticsTool/umApi.js";
import { error } from 'util';

export default {
  mixins: [validationMixin],
  validations: {
    Companies: { required },
    Mail: { required },
    Name: { required },
    Surname: { required }
  },

  data: () => ({
    id: 0,
    Companies: "",
    comp: [],
    Mail: "",
    selectedMail: "",
    Mails: [],
    MailsObj: {},
    Name: "",
    Surname: "",
    errorAlert: false,
    errorMessage: "",
    loadingMail:false,

    objectToPassOnOperatorsTable : {
      Id: 0,
      CompanyCode: "",
      Name: "",
      Surname: "",
      Mail: ""
    },

    msgInsertError: "Elemento richiesto",
    rules: {
      isFercam: value => {  
        const pattern = /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(fercam)\.com$/;
        return pattern.test(value) || "L'operatore deve essere un Operatore Fercam (@fercam.com)";
      }
    }
  }),

  computed: {
    edit() {
        return this.$route.params.Id > 0
      },

    CompaniesErrors() {
      const errors = [];
      if (!this.$v.Companies.$dirty) return errors;
      !this.$v.Companies.required && errors.push(this.msgInsertError);
      return errors;
      },
    MailErrors() {
      const errors = [];
      if (!this.$v.Mail.$dirty) return errors;
      !this.$v.Mail.required && errors.push(this.msgInsertError);
      return errors;
      },
    NameErrors() {
      const errors = [];
      if (!this.$v.Name.$dirty) return errors;
      !this.$v.Name.required && errors.push(this.msgInsertError);
      return errors;
      },
    SurnameErrors() {
      const errors = [];
      if (!this.$v.Surname.$dirty) return errors;
      !this.$v.Surname.required && errors.push(this.msgInsertError);
      return errors;
      }
  },

  created() {
    const id = this.$route.params.Id;
    
    //carico le mie companies

    companiesApi.GetCompanies().then(response => {
      
      //carico le mie companies e le metto dentro la mia label
      this.comp = response.data;
      if(this.comp.length == 1){
        this.Companies = this.comp[0]
      }
    })

    //se abbiamo l'id compilo i campi che sono già esistenti
    if (id) {
      operatorsApi.GetOperator(id).then(response => {
        
        this.Companies = response.data.companyCode;
        let emailObj= {
          Email: response.data.mail
        }
        this.Mails.push(emailObj);
        this.Mail = response.data.mail;
        this.Name = response.data.name;
        this.Surname = response.data.surname;
      });
    }

    // stocksApi.GetStocksInternal().then(response => {
    //   this.stocks = response.data;
    // });
  },

  methods: {

    back() {
      router.push("/Operators/Index");
    },

    changeMail(event){
      
      if(event){
        this.selectedMail = this.Mails.filter(x => x.Email == event)[0].Email;
        
        this.autoFill(event);
      }
    },

    loadMail: debounce(function(event) {
      if(event.target.value.length > 2) {
        this.loadingMail = true;
        var email = event.target.value;
        
        umApi.vUsersReadByEmail(email).then(({ data }) => {
          this.Mails = data;
          this.loadingMail = false;
        })
      }
    },200),

    //metodo per compilarmi in automatico le caselle
    autoFill(data){
      
      umApi.vUsersReadByEmail(data).then(response => {
        
          this.Name = response.data[0].FirstName,
          this.Surname = response.data[0].LastName
          
          this.loadingMail = false;
        })
    },

    submit() {
      
      this.$v.$touch();
      
      const id = this.$route.params.Id;
      if (
        this.$v.Companies.$error ||
        this.$v.Mail.$error ||
        this.$v.Name.$error ||
        this.$v.Surname.$error ||
        !this.$refs.form.validate()
      ) {
        
        return;
      }
          

      
      
      //è una modifica
      if (id) {        

    let operatorUpdate = {
        Id: id,
        CompanyCode: this.Companies,
        Mail: this.Mail,
        Name: this.Name,
        Surname: this.Surname
      };

        //modifico i dati nel mio db locale
        operatorsApi.EditOperator(operatorUpdate).then(response => {
          
          router.push("/Operators/Index");
        
        }).catch(error => {
            this.errorAlert = true;
            this.errorMessage = error.response.data;
          });
        
        //modifico i dati nel db dell'usermanagement
        //TODO? this.SaveOperatorOnUserManagement(operator);

      //è un inserimento
      } else {
     
      let operatorCreate = {
        Id: id,
        CompanyCode: this.Companies.code,
        Mail: this.Mail,
        Name: this.Name,
        Surname: this.Surname
      };
        //inserisco i dati nel mio db locale
        operatorsApi.CreateOperator(operatorCreate).then(response => {
          
          router.push("/Operators/Index");
        }).catch(error => {
          this.errorAlert = true;
          this.errorMessage = error.response.data;
        })

        //inserisco i dati nel db dell'usermanagement
        //this.SaveOperatorOnUserManagement(operator);
        //router.push("Index");
      }
    },

    clear() {
      this.$v.$reset();
      this.Companies = "";
      this.Email = "";
      this.Name = "";
      this.Surname = "";
    },
  }
};
</script>
